export default __webpack_public_path__ + "static/media/bg-remove.1fc965f2.png";